import {createSlice} from "@reduxjs/toolkit";

const initialOrdersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  orderForEdit: undefined,
  ordersUpdated: false,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState: initialOrdersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getOrderById
    orderFetched: (state, action) => {
      state.actionsLoading = false;
      state.orderForEdit = action.payload.orderForEdit;
      state.error = null;
    },

    // findOrders
    ordersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createOrder
    orderCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.order);
    },
    // updateOrder
    orderUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.order.id) {
          return action.payload.order;
        }
        return entity;
      });
    },
    // deleteOrder
    orderDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteOrders
    ordersDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },


    addedToWave: (state, action) => {
      state.ordersUpdated = !state.ordersUpdated;
      state.error = null;
      
    },
    orderPaid: (state, action) => {
      state.actionsLoading = false;
      state.ordersUpdated = !state.ordersUpdated;
      state.error = null;
    },
    notePosted: (state, action) => {
      state.actionsLoading = false;
      state.ordersUpdated = !state.ordersUpdated;
      state.error = null;
    },
    orderCancelled: (state, action) => {
      state.actionsLoading = false;
      state.ordersUpdated = !state.ordersUpdated;
      state.error = null;
    },
    orderPending: (state, action) => {
      state.actionsLoading = false;
      state.ordersUpdated = !state.ordersUpdated;
      state.error = null;
    },
  }
});
